<template>
  <loader
    :is-loading="isLoadingCurrent"
    :is-empty="!properties_360"
    i18n-path="properties_360"
    v-resize="onResize"
  >
    <v-tabs
      active-class="primary--text"
      :height="FRI_TABS_HEIGHT"
      :background-color="$vuetify.theme.themes[theme].background"
      v-model="tab"
      grow
      show-arrows
    >
      <v-tab>
        <button-icon
          icon="mdi-file-document-outline"
          label="Informations générales"
          :active="tab === 0"
        />
      </v-tab>
      <v-tab>
        <button-icon
          icon="mdi-briefcase-outline"
          label="Opération de maintenance"
          :active="tab === 1"
        />
      </v-tab>
      <v-tab v-if="properties_360.p1_monitoring">
        <button-icon icon="mdi-poll" label="Relèves" :active="tab === 2" />
      </v-tab>
      <v-tab>
        <button-icon
          icon="mdi-lightbulb-on-outline"
          label="Efficacité énergétique"
          :active="properties_360.p1_monitoring ? tab === 3 : tab === 2"
        />
      </v-tab>
      <v-tab>
        <button-icon
          icon="mdi-wrench"
          label="Matériel"
          :active="properties_360.p1_monitoring ? tab === 4 : tab === 3"
        />
      </v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <v-tabs-items
      v-model="tab"
      class="overflow-y-auto overflow-x-hidden"
      :style="{
        height: height + 'px',
        background: $vuetify.theme.themes[theme].background,
      }"
    >
      <v-tab-item>
        <general-informations-tab />
      </v-tab-item>
      <v-tab-item>
        <maintenance-operations-tab />
      </v-tab-item>
      <v-tab-item v-if="properties_360.p1_monitoring">
        <summary-property-readings :property-id="properties_360.id" />
      </v-tab-item>
      <v-tab-item>
        <energy-performance-tab />
      </v-tab-item>
      <v-tab-item>
        <equipment-tab :height="height" />
      </v-tab-item>
    </v-tabs-items>
  </loader>
</template>

<script>
import resizable from '@/business/mixins/resizable';
import {
  POPUP_BOTTOM_HEIGHT,
  POPUP_TOP_HEIGHT,
} from '@/components/dialogs/customDialog.styles';
import { TABS_HEIGHT } from '@/pages/eDispatch/requestDetails/rightSide/requestsRightSide';
import FRI_TABS_HEIGHT from '@/pages/FRI/summaryPropertySheet.styles';
import { mapGetters } from 'vuex';
import Loader from '@/components/widgets/Loader';
import SummaryPropertyReadings from '@/pages/FRI/readings/SummaryPropertyReadings';
import ButtonIcon from './ButtonIcon';
import GeneralInformationsTab from './GeneralInformationsTab';
import EnergyPerformanceTab from './EnergyPerformanceTab';
import EquipmentTab from './EquipmentTab';
import MaintenanceOperationsTab from './MaintenanceOperationsTab';

export default {
  name: 'SummaryPropertySheet',
  mixins: [resizable],
  components: {
    Loader,
    ButtonIcon,
    GeneralInformationsTab,
    EnergyPerformanceTab,
    EquipmentTab,
    MaintenanceOperationsTab,
    SummaryPropertyReadings,
  },
  data() {
    return {
      tab: null,
      FRI_TABS_HEIGHT,
    };
  },
  computed: {
    ...mapGetters({
      isLoadingCurrent: 'properties_360/isLoadingCurrent',
      properties_360: 'properties_360/current',
    }),
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
    height() {
      if (this.isModalOpen) {
        return (
          this.boilerplatePopupHeight -
          (TABS_HEIGHT +
            FRI_TABS_HEIGHT +
            POPUP_TOP_HEIGHT +
            POPUP_BOTTOM_HEIGHT) -
          30
        );
      }
      return this.contentHeight - FRI_TABS_HEIGHT - 48;
    },
  },
};
</script>
